import {
  ACTIVE_ORGANIZATION_ID_COOKIE,
  COOKIE_EXPIRY_DAYS,
} from '@lib/constants/cookies';
import Cookies from 'js-cookie';

const listeners = new Set<() => void>();

/** The raw active-org cookie; resolve it with `resolveActiveOrg` before use. */
export const readActiveOrgCookie = (): string | undefined =>
  Cookies.get(ACTIVE_ORGANIZATION_ID_COOKIE);

/**
 * Writes the active-org cookie and tells subscribers, so readers outside
 * OrganizationsProvider (the header cart count) follow an org switch that does
 * not reload the page.
 */
export const writeActiveOrgCookie = (organizationId: string): void => {
  Cookies.set(ACTIVE_ORGANIZATION_ID_COOKIE, organizationId, {
    expires: COOKIE_EXPIRY_DAYS,
  });
  listeners.forEach((listener) => listener());
};

/** `useSyncExternalStore` subscribe for `readActiveOrgCookie`. */
export const subscribeToActiveOrgCookie = (
  listener: () => void
): (() => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};
